import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './components/navbar';
import Footer from './components/footer';
import Production from './assets/pages/Production';
import AboutMe from './assets/pages/AboutMe';
import Photos from './assets/pages/Photos';
import HomeGallery from './assets/pages/HomeGallery';
import NotFound from './assets/pages/NotFound';
import './App.css';
import './input.css';

function App() {
  // const isMobileView = window.innerWidth <= 768;

  return (
    <Router>
      <div className="App min-h-screen flex flex-col">
        <Navbar />

        <main className="flex-1">
          <Routes>
            <Route path="/" element={<HomeGallery/>} />
            <Route path="/photo" element={<Photos />} />
            <Route path="/production" element={<Production />} />
            <Route path="/info" element={<AboutMe />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>

    // {isMobileView ? <FooterNavbar /> : null} !>
  );
}

export default App;
